/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartPastHistoryHospitalAliases {
  CONTEXTUAL_BAR_PAST_HISTORY_HOSPITAL_DETAIL = 'contextual-bar-past-history-hospital-detail',
  FIELD_DISEASE = 'field-disease',
  FIELD_END_DATE = 'field-end-date',
  FIELD_NOTES = 'field-notes',
  FIELD_START_DATE = 'field-start-date',
  FORM_PAST_HISTORY_HOSPITAL = 'form-past-history-hospital',
  INPUT_END_DATE = 'input-end-date',
  INPUT_START_DATE = 'input-start-date',
  LAYOUT_PAST_HISTORY_HOSPITAL_DETAIL = 'layout-past-history-hospital-detail',
  PANEL_PAST_HISTORY_HOSPITAL = 'panel-past-history-hospital',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { MyChartPastHistoryHospitalAliases };
